<template>
  <VRow no-gutters>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <VCol cols="12" class="font-weight-regular" v-html="vacancy.description" />
    <VCol cols="12">
      <template v-if="vacancy.skills.length">
        <div class="display-2 mt-10">
          {{ $t('skills') }}
        </div>
        <VDivider class="mt-4" />
        <VChipGroup
          column
          class="mt-4"
        >
          <VChip
            v-for="skill in vacancy.skills"
            :key="skill"
            label
          >
            {{ skill }}
          </VChip>
        </VChipGroup>
      </template>
      <template v-if="vacancy.faq.length">
        <div class="display-2 mt-10">
          {{ $t('FAQ') }}
        </div>
        <VacancyFaq
          :faq="vacancy.faq"
          class="mt-4"
        />
        <VDivider />
      </template>
      <template v-if="vacancy.address">
        <div class="font-weight-bold mt-10">
          {{ $t('address') }}
        </div>
        <VRow no-gutters>
          <VCol cols="12">
            <div class="mt-3 font-weight-regular">
              {{ vacancy.address.address }}
            </div>
            <ClientOnly>
              <AppAddressMap
                :address="vacancy.address"
                class="vacancy-address mt-2 pt-8"
              />
            </ClientOnly>
          </VCol>
        </VRow>
      </template>
      <div class="font-weight-light caption grey--text text--darken-2 mt-2">
        {{ $t('published') }}:
        <AppDateFormatted :value="vacancy.publishedFrom" />
      </div>
    </VCol>
  </VRow>
</template>

<script>
import { mdiCircleMedium } from '@mdi/js';
import ClientOnly from 'vue-client-only';
import VacancyFaq from './VacancyFaq.vue';
import AppAddressMap from '../AppAddressMap.vue';
import AppDateFormatted from '../AppDateFormatted.vue';

export default {
  name: 'VacancyCard',
  components: {
    AppDateFormatted,
    ClientOnly,
    AppAddressMap,
    VacancyFaq,
  },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      addressIcon: mdiCircleMedium,
    };
  },
};
</script>

<style lang="scss" scoped>
  .vacancy-address {
    width: 100%;
    height: 180px;
  }

  ::v-deep {
    ul, ol {
      padding-left: 0;
      margin-bottom: 30px;

      li {
        margin-left: 17px;
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
  skills: Key skills required
  FAQ: FAQ
  address: Address
  published: Job published
</i18n>

<i18n locale="ru" lang="yaml">
  skills: Ключевые навыки
  FAQ: Вопросы-ответы
  address: Адрес
  published: Вакансия опубликована
</i18n>
